import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { Control, Controller, FieldErrors, UseFormSetValue } from "react-hook-form";
import SitesCheckboxes from "components/forms/SitesCheckboxes";
import { SitesDuForfait } from "hooks/useSitesDuForfait";
import { cmsDesSites } from "utils";

// Sites d'une intervention : ceux de son forfait, cochés par défaut et décochables.
// Le CMS suit les sites cochés et reste modifiable : l'e-mail l'écrit tel quel au client ; il est à saisir pour un site « autre ».
// Sans site sur le forfait, rien ne s'affiche ici : le formulaire garde ses champs texte
export default function InterventionSites(props: {
  choix: SitesDuForfait;
  control: Control<InterventionType>;
  errors: FieldErrors<InterventionType>;
  setValue: UseFormSetValue<InterventionType>;
}) {
  const { choix, control, errors, setValue } = props;
  if (!choix.pret || choix.sites.length === 0) {
    return null;
  }
  return (
    <>
    <FormControl isInvalid={!!errors.idsites} mb={4}>
      <FormLabel as="div">Sites concernés</FormLabel>
      <Controller
        name="idsites"
        control={control}
        rules={{ validate: (ids) => (ids ?? []).length > 0 || "Cochez au moins un site" }}
        render={({ field }) => (
          <SitesCheckboxes
            sites={choix.sites}
            value={field.value ?? []}
            onChange={(ids) => {
              field.onChange(ids);
              setValue("cms", cmsDesSites(choix.sites.filter((site) => ids.includes(site.id))));
            }}
          />
        )}
      />
      <FormErrorMessage>{(errors.idsites as { message?: string })?.message}</FormErrorMessage>
    </FormControl>
    <FormControl isInvalid={!!errors.cms} mb={4}>
      <FormLabel htmlFor="cms">CMS</FormLabel>
      <Controller
        name="cms"
        control={control}
        rules={{ validate: (cms) => Boolean((cms ?? "").trim()) || "Champ obligatoire : ce texte figure dans l'e-mail" }}
        render={({ field }) => <Input id="cms" placeholder="Par exemple : Application web" {...field} value={field.value ?? ""} />}
      />
      <FormErrorMessage>{errors.cms?.message}</FormErrorMessage>
    </FormControl>
    </>
  );
}
